import Vue from "vue";
import Vuex from "vuex";
import { createStore } from 'vuex-extensions';
import { gpt } from "@/store/modules/gpt";
import { call } from "./modules/call";
import { download } from "./modules/download";
import { account } from "./modules/account";
import { project } from "./modules/project";
import { alert } from "./modules/alert";
import { interactions } from "./modules/interactions";
Vue.use(Vuex);

const store = createStore(Vuex.Store, {
  modules: {
    gpt,
    call,
    download,
    account,
    project,
    alert,
    interactions,
  },
});

export default store;
